import React, { useCallback, useState } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Grid2,
} from "@mui/material";

import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import CloseButton from "../../../Components/CloseButton";
import { PrimaryFormLoadingActionButton } from "../../../Features/Table/GenericDraggableTable/TableStyles";
import VisualizationSettings from "./VisualizationSettings";
import VisualizationPreview from "./VisualizationPreview";
import { resetBinaryChartData } from "../Common/CommonFunctions";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 8,
    boxShadow: theme.shadows[5],
    width: "1304px",
    maxWidth: "100%",
    backgroundColor: '#F4F4F4',
    margin: 0,
    maxHeight: '100%',
  },
}));

const CreateVisualizationDialog = ({ initialChartData = {}, batteryID, selectedDate, onSaveChart, batteryInfo = {}, selectedEntity = null }) => {

  const {t} = useTranslation(['common', 'digital_twin']);
  const [open, setOpen] = useState(false);
  const [previewChartData, setPreviewChartData] = useState(initialChartData);
  const isDisabled = !Boolean(batteryID);
  const [chartEntities, setChartEntities] = useState([]);
  const [isChartLoading, setIsChartLoading] = useState(false);

  const handleOpen = () => {
    setOpen(true)
  };

  const handleClose = () => {
    setOpen(false);
  };

  const fetchChartData = useCallback(async (entities) => {
    if (!entities || entities.length === 0) {
      setPreviewChartData({});
      setIsChartLoading(false);
      return;
    }

    setIsChartLoading(true);

    try {
      const resetChartDataResponse = await resetBinaryChartData(entities, selectedDate?.value);

      setPreviewChartData(resetChartDataResponse);
    } catch (error) {
      console.error("Error fetching chart data:", error);
      setPreviewChartData({});
    } finally {
      setIsChartLoading(false);
    }
  }, [selectedDate]);

  const handleOnEntitiesChange = useCallback((entities) => {
    setChartEntities(entities);
    fetchChartData(entities);
  }, [fetchChartData]);

  const handleOnCreate = () => {
    onSaveChart(chartEntities);
    handleClose();
  }

  return (
    <>
      <PrimaryFormLoadingActionButton
            onClick={handleOpen}
            sx={{
                backgroundColor: isDisabled ? '#E6E6E6' : '#6D72F6',
                color: isDisabled ? '#8F8F8F' : '#FFFFFF'
            }}
            disabled={isDisabled}
        >
            Create
        </PrimaryFormLoadingActionButton>

      <StyledDialog open={open} onClose={handleClose}>
        <DialogContent sx={{py: 3}}>
          <Grid2 sx={{ mb: 3 }}>
            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3}}>
              <Typography variant="fw500s20c000000" sx={{ lineHeight: '24px' }}>Create Visualisation</Typography>
              <CloseButton onClick={handleClose} />
            </Box>
            <Grid2 container gap={1.5} flexWrap={'nowrap'}>
                <VisualizationSettings entities={chartEntities} batteryID={batteryID} onEntitiesChange={handleOnEntitiesChange} />
                <VisualizationPreview selectedDate={selectedDate} chartData={previewChartData} onSave={handleOnCreate} isLoading={isChartLoading} batteryInfo={batteryInfo} selectedEntity={selectedEntity} />
            </Grid2>
          </Grid2>
        </DialogContent>
      </StyledDialog>
    </>
  );
};

export default CreateVisualizationDialog;
